export default "__VITE_ASSET__CBl6HQnt__"